/*
 * @Descripttion: 
 * @version: 
 * @Author:
 * @Date: 2021-08-27 09:56:19
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-27 10:00:40
 */
import axios from 'axios'

export const deleteNews = (id) => {
    // debugger
    return new Promise((resolve, reject) => {
        axios.delete(`${global.url.news}/news/deleteNews/${id}`).then((res) => {
            let data = res.data
            resolve(data)
        }).catch((e) => {
            reject(e) 
        })
    })
}

export const deleteNotice = (id) => {
    // debugger
    return new Promise((resolve, reject) => {
        axios.delete(`${global.url.news}/notice/deleteNotice/${id}`).then((res) => {
            let data = res.data
            resolve(data)
        }).catch((e) => {
            reject(e) 
        })
    })
}